import React, { useState } from 'react';
import axios from './api/axiosConfig';
import './PasswordResetPage.css';
import { BASE_URL } from './api/config';

const RESET_API_URL = `${BASE_URL}/api/reset-password`;

export default function PasswordResetPage({ navigateTo }) {
  const [nickname, setNickname] = useState('');
  const [realName, setRealName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [resultPassword, setResultPassword] = useState(''); // 非空表示结果弹窗打开

  const handleReset = async () => {
    if (!nickname.trim()) { alert('请输入昵称'); return; }
    if (!realName.trim()) { alert('请输入真实姓名'); return; }

    setSubmitting(true);
    try {
      const response = await axios.post(RESET_API_URL, {
        nickname: nickname.trim(),
        real_name: realName.trim(),
      });
      if (response.data.success && response.data.new_password) {
        setResultPassword(response.data.new_password);
      }
    } catch (error) {
      console.error('密码重置失败:', error);
      const errorMsg = error.response?.data?.detail || error.message || '密码重置失败';
      alert(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(resultPassword);
      } else {
        // 降级方案：隐藏 textarea + execCommand
        const textArea = document.createElement('textarea');
        textArea.value = resultPassword;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setResultPassword('');
    } catch (err) {
      console.error('复制失败:', err);
      alert('复制失败，请手动复制');
    }
  };

  return (
    <div className="password-reset-page">
      <div className="password-reset-header">
        <button className="password-reset-back" onClick={() => navigateTo('home')}>←</button>
        <h1 className="password-reset-title">密码重置</h1>
      </div>

      <div className="password-reset-body">
        <div className="password-reset-form">
          <label className="password-reset-label">昵称</label>
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            className="password-reset-input"
            placeholder="请输入昵称"
          />

          <label className="password-reset-label">真实姓名</label>
          <input
            type="text"
            value={realName}
            onChange={(e) => setRealName(e.target.value)}
            className="password-reset-input"
            placeholder="请输入真实姓名"
          />

          {/* 空三行 */}
          <div className="password-reset-spacer" />

          <button className="password-reset-submit" onClick={handleReset} disabled={submitting}>
            {submitting ? '处理中...' : '密码重置'}
          </button>
        </div>
      </div>

      {resultPassword && (
        <div className="password-reset-modal-overlay">
          <div className="password-reset-modal">
            <div className="password-reset-modal-title">新的密码</div>
            <div className="password-reset-modal-password">{resultPassword}</div>
            <button className="password-reset-copy-btn" onClick={handleCopy}>复制</button>
          </div>
        </div>
      )}
    </div>
  );
}